import axios from "axios";
import { base_url } from "../../utils/baseUrl";
import { config } from "../../utils/axiosconfig";

const getNewss = async () => {
  const response = await axios.get(`${base_url}news/getNews`);

  return response.data;
};
const createNews = async (formData) => {
  const response = await axios.post(`${base_url}news/addNews`, formData);

  return response.data;
};
const updateNews = async (News) => {
  const formData = new FormData();
  formData.append("author", News.NewsData.get("author"));
  formData.append("title", News.NewsData.get("title"));
  formData.append("content", News.NewsData.get("content"));
  formData.append("categoryName", News.NewsData.get("categoryName"));
  formData.append("audio",News.NewsData.get("audio"));
  formData.append("image", News.NewsData.get("image"));

  const response = await axios.put(
    `${base_url}news/editNews/${News.id}`,
    formData,
    config
  );

  return response.data;
};

const getNews = async (id) => {
  const response = await axios.get(`${base_url}news/getById/${id}`);

  return response.data;
};

const deleteNews = async (id) => {
  const response = await axios.delete(`${base_url}news/deleteNews/${id}`, config);

  return response.data;
};
const NewsService = {
  getNewss,
  createNews,
  getNews,
  updateNews,
  deleteNews,
};

export default NewsService;
